import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';
import { ToastService } from '../toast.service';

@Component({
  selector: 'app-create-promotions',
  templateUrl: './create-promotions.component.html',
  styleUrls: ['./create-promotions.component.scss'],
})
export class CreatePromotionsComponent {
  percentage;
  amount;
  name;
  description;
  code;
  loader: boolean = false;
  editBool:boolean=false;
  active: boolean = true;
  activeInd: boolean = true;
  deletepromo:boolean = false;
  item:any;
  promoCategory:any =[];
  promotionCategory;
  promotionId;
  promoType:any =[];
  promotionType;
  typeId;
  category;
  cateName;
  cateId;
  id;
  usageCount: any =[];
  maxAmount:any=[];
  selectedCatagory:any=[];
  getCatagory:any=[];
constructor(public service: ApiService,
  public handler: HandlerService,
  public toast: ToastService,
  public router: Router,
  private bottomSheet: MatBottomSheet,
  public platform:Platform,
  public auth:AuthService) { }
  ionViewWillEnter() {
    this.service.getAllCategory().subscribe(res => {
      this.promoCategory = res;
         },
      err => {
        this.handler.err(err);
        this.loader = false;
      })
    let url=window.location.href
    if(url.includes('edit')) {
      this.editBool=true;
      this.deletepromo=true;
      this.id= window.location.href.split('/').pop();
      this.service. getPromotionById(this.id).subscribe((res:any)=>{
      this.item=res;

      this.name= res.name;
      this.description = res.description;
      this.code = res.code;
      this.percentage = res.discountPercentage;
      this.amount= res.fixedAmount;
      this.promotionId=res.promotionCategory;
      this.cateId = res.purchaseCategoryId;
      this.typeId=res.promotionType;
      this.activeInd = res.activeInd;
      this.usageCount = res.usageCount;
      // this.maxAmount = res.maxUpto;
      this.getCatagory =res.couponServiceCategory;
      setTimeout(() => {
        this.category.map(res1 => {
          if (res1.id == this.cateId) {
            this.cateName = res1.name;
            this.cateId = res1.id;
          }
        })
      }, 1000);
       this.service.getAllCategory().subscribe((dat1:any) => {
        dat1.map(dat=>{
          if(dat.id==res.promotionCategory){
            this.promotionCategory = dat.name;
            this.promotionId = dat.id;
          }
        })
      })
      this.service.getAllType().subscribe((dat1:any) => {
      
        dat1.map(dat=>{
         if(dat.id==res.promotionType){
           this.promotionType = dat.name;
           this.typeId = dat.id;
           
         }
       })
     })

      
      this.loader = false;
    })
    err=>{
      this.handler.err(err);
      this.loader=false;
    }
  }
  else{
    this.editBool = false;
  }
  this.getCategory(); 

 
    this.service.getAllType().subscribe(res => {
      this.promoType = res;
    },
      err => {
        this.handler.err(err);
        this.loader = false;
      })
  }


  create() {
    var cateArray=[];
    if(this.selectedCatagory.length>0&&this.promotionId&&this.typeId&&(this.percentage || this.amount)){
    this.loader = true;
    this.selectedCatagory.map(res=>{
      cateArray.push({
        usageCount:this.usageCount,
        couponCode: this.code,
        serviceCategoryId:res.id
      })
    })
    if(this.code){
      this.code = this.code.toUpperCase();
    }
    var post={
      "name": this.name,
      "description": this.description,
      "code": this.code,
      "discountPercentage": this.percentage,
      "fixedAmount": this.amount,
      "promotionCategory": this.promotionId,
      "promotionType": this.typeId,
       "activeInd": this.activeInd,
       "usageCount":this.usageCount,
      //  "maxUpto":this.maxAmount,
       "couponServiceCategory":cateArray,
    }
    this.service. createPromotion(post).subscribe(res=>{
      this.handler.res("Promotion Created Successfully");
      this.loader = false;
      this.router.navigate(['/manage-promotions'])

    },
    err=>{
      this.loader=false;
      this.handler.err(err);
    })
  }else{
    this.handler.staticError('Please Enter Required Fields')
  }
  }
  editService() {
    if(this.code){
      this.code = this.code.toUpperCase();
    }
    var cateArray=[]
    if(this.selectedCatagory.length>0&&this.promotionId&&this.typeId&&(this.percentage || this.amount)){
    this.loader = true;
    this.selectedCatagory.map(res=>{
      cateArray.push({
        usageCount:this.usageCount,
        couponCode: this.code,
        serviceCategoryId:res.id
      })
    })
    this.item.name=this.name;
    this.item.description=this.description;
    this.item.code=this.code;
    this.item.discountPercentage=this.percentage;
    this.item.fixedAmount=this.amount;
    this.item.promotionCategory=this.promotionId;
    this.item.promotionType=this.typeId;
    this.item.activeInd = this.activeInd;
    this.item.usageCount = this.usageCount;
    // this.item.maxUpto = this.maxAmount;
    this.item.couponServiceCategory = cateArray
    this.service.updatePromotion(this.id,this.item).subscribe(res=>{
      this.handler.res("Promotion Updated Successfully");
      this.loader = false;
      this.router.navigate(['/manage-promotions'])

    },
    err=>{
      this.loader=false;
      this.handler.err(err);
    })
  }else{
    this.handler.staticError('Please Enter Required Fields')
  }
  }
  cancel() {
    this.router.navigate(['/manage-promotions']);
  }
  promotionCatagory(){
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.promoCategory,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.promotionCategory = res.name;
      this.promotionId = res.id;
    });
   }
   openBottomSheetPurchase(){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;
       this.selectedCatItem(this.cateId)  
        }
    });
  }
  selectedCatItem(id){
    let catType: any = [];
    catType = this.category.filter(res => { return res.id == id })
    this.selectedCatagory.push(catType[0])
    this.selectedCatagory = this.selectedCatagory.filter((x, i, a) => a.indexOf(x) == i);
  }
  removeChip(i) {
    this.selectedCatagory.splice(i, 1);
  }
  getCategory(){
    var z=[];
    this.service.getOrgCategory().subscribe((res:any)=>{
      this.category=res;
      this.category.map(dat=>{
        if(dat.id==this.cateId){
          this.cateName = dat.name;
        }
      })
      this.category.map(res=>{
        this.getCatagory.map(dat2=>{
         if(res.id==dat2.serviceCategoryId){
           z.push(res)
         }  
        })
      })
      this.selectedCatagory = z.filter((x, i, a) => a.indexOf(x) == i);
      this.loader=false;
    })
  }
   openPromotionType(){
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.promoType,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.promotionType = res.name;
      this.typeId = res.id;
    });
   } 
   deletePromotion(){
    this.loader=true;
    this.service.deletePromotion(this.id).subscribe(res=>{
     this.loader=false;
      this.handler.res("Deleted successfully")
      this.router.navigate(['/get-promotions'])
    },
    err=>{
      this.handler.err(err)
      this.loader=false
    })
  }  
      
}

